(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ"] && !Shopify.designMode) return;
  try {
    

$('.question').on('click',function(){


$(this).next().slideToggle();
  $(this).toggleClass("active");

  
})


   // (() => {
  //   [...document.getElementsByClassName('js-collapse-trigger')].forEach(button => {
  //     let target = button.nextElementSibling;
  //     button.addEvent('click', function() {
  //       if(this.classList.contains('active')){
  //         this.classList.remove('active');
  //         target.style.height = "";
  //         target.classList.remove('is-open');
  //       }else{
  //         this.classList.add('active');
  //         target.style.height = target.firstElementChild.offsetHeight + "px";
  //         target.classList.add('is-open');
  //       }
  //     })
  //   })
  // })()

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["all-categories-list"] && !Shopify.designMode) return;
  try {
    


  $('.all-categories-list-primay-link').on('click',function(e){
    e.preventDefault();

    $(this).toggleClass("active-primary");
    $(this).next().slideToggle();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2c-dealzone"]) return;
  try {
    


setInterval(function time(){

  
  
  var d = new Date();
  var hours = 24 - d.getHours();
  var min = 60 - d.getMinutes();
  if((min + '').length == 1){
    min = '0' + min;
  }
  var sec = 60 - d.getSeconds();
  if((sec + '').length == 1){
        sec = '0' + sec;
  }

  $(".dpb-deal-timer").html(hours+':'+min+':'+sec)
  // jQuery('#the-final-countdown p').html(hours+':'+min+':'+sec)

  
  // bar width calulation:
  var start = new Date;
  start.setHours(24, 0, 0);

  var now = new Date;
    if (now > start) { // too late, go to tomorrow
      start.setDate(start.getDate() + 1);
    }
    var remain = ((start - now) / 1000);
    var pc = remain * (100 / 86400); 
  $('.dpb-progressbar-in').css({"width": pc + '%'});
   
    
}, 1000);

  

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2c-hero"]) return;
  try {
    


$(".b2c-hero-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
  fade:true,
    speed: 300,
    slidesToShow: 1,
    prevArrow: "<span class='b2c-button b2c-hero-left'><i class='fal fa-chevron-left'></i></span>",
    nextArrow: "<span class='b2c-button b2c-hero-right'><i class='fal fa-chevron-right'></i></span>",
  });  
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-ph-business"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new-backup"]) return;
  try {
    




  $('.product-popup-close').on("click",function(){
        $(".product-popup").fadeOut();

  })
  $('.product-popup-btn').on("click",function(){
    console.log("Clicked");
        $(".product-popup").fadeIn();

    var datatext=$(this).attr("data-targetit")
console.log(datatext)
    if(datatext == "box-keyfeatures")
    {
      $('.product-popup-tabs li').siblings().removeClass('active');
       $('.product-popup-tabs li:nth-child(1)').addClass('active');
    }
    else if(datatext == "box-specs")
    {
      $('.product-popup-tabs li').siblings().removeClass('active');
       $('.product-popup-tabs li:nth-child(2)').addClass('active');
    }
    else if(datatext == "box-details")
    {
      $('.product-popup-tabs li').siblings().removeClass('active');
       $('.product-popup-tabs li:nth-child(3)').addClass('active');
    }

  })


  
      // Function to generate a random number in the range 100 to 600 (inclusive)
    function getRandomNumberInRange() {
      const min = 100;
      const max = 200;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // Call the function and store the random number in a variable
    const randomNumber = getRandomNumberInRange();
      console.log(randomNumber);

      $('.ppb-count').html(randomNumber);


       $('.product-carousel-main').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          fade: false,
          asNavFor: '.product-carousel-thumbnails'
      });
      $('.product-carousel-thumbnails').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.product-carousel-main',
          dots: false,
        arrows:false,
          focusOnSelect: true
      });



    var prod_quantity_mob = $('.mpi-quantity');

    if ($(window).width() < 767) {


  console.log(prod_quantity_mob)

    $('.main-product-info .mpi-variations-wrapper').prepend(prod_quantity_mob)

  }






    window.addEventListener('load', function () {




         $('.btn-dec').on('click', function(){
      	console.log("decrease");
          let inputfield = $(this).next();
        	let currVal = $(inputfield).val();
        	if( parseInt(currVal) > parseInt(1)){
        	$(inputfield).val(parseInt(currVal) - parseInt(1));
        }
      })

      $('.btn-inc').on('click', function(){
      	console.log("increase");
        	let inputfield = $(this).prev();
        	let currVal = $(inputfield).val();

        	$(inputfield).val(parseInt(currVal) + parseInt(1));

      })


    });



$('.product-variant-select').change(function(){
  var variantPrice = $(this).children('option:selected').data('variantprice');
  var variantComparePrice = $(this).children('option:selected').data('variantcompare');

  $('.mpi-price h5 u').html(variantPrice)

  console.log("VP :",variantPrice )

  if(variantComparePrice != "")
  {
    $('.mpi-price h5 s').html(variantComparePrice)
  }

   
});
 


  //copy promo to clipboard


    let buttonElement = document.querySelector('.promo-copy-code') !== null
 
  if (buttonElement) {
    let text = document.querySelector('.promo-copy-code').innerHTML;
    const copyContent = async () => {
      try {
        await navigator.clipboard.writeText(text);
        console.log('Content copied to clipboard');
        buttonElement.classList.add("promo-copied");
        document.querySelector('.mpi-pwd-code small').innerHTML = "Coupon Copied";
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    }
  }


 // window.addEventListener('load', function () {
  // let checkInstallation = document.querySelector("#tcustomizer-app")  !== null;


  // if(checkInstallation) 
  // {
    // $('.product-form').prepend(checkInstallation);
  // }

 // });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    




  $('.product-popup-close').on("click",function(){
        $(".product-popup").fadeOut();

  })
  $('.product-popup-btn').on("click",function(){
    console.log("Clicked");
        $(".product-popup").fadeIn();

    var datatext=$(this).attr("data-targetit")
console.log(datatext)
    if(datatext == "box-keyfeatures")
    {
      $('.product-popup-tabs li').siblings().removeClass('active');
       $('.product-popup-tabs li:nth-child(1)').addClass('active');
    }
    else if(datatext == "box-specs")
    {
      $('.product-popup-tabs li').siblings().removeClass('active');
       $('.product-popup-tabs li:nth-child(2)').addClass('active');
    }
    else if(datatext == "box-details")
    {
      $('.product-popup-tabs li').siblings().removeClass('active');
       $('.product-popup-tabs li:nth-child(3)').addClass('active');
    }

  })


  
      // Function to generate a random number in the range 100 to 600 (inclusive)
    function getRandomNumberInRange() {
      const min = 100;
      const max = 200;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // Call the function and store the random number in a variable
    const randomNumber = getRandomNumberInRange();
      console.log(randomNumber);

      $('.ppb-count').html(randomNumber);


       $('.product-carousel-main').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          fade: false,
          asNavFor: '.product-carousel-thumbnails'
      });
      $('.product-carousel-thumbnails').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.product-carousel-main',
          dots: false,
        arrows:false,
          focusOnSelect: true
      });



    var prod_quantity_mob = $('.mpi-quantity');

    if ($(window).width() < 767) {


  console.log(prod_quantity_mob)

    $('.main-product-info .mpi-variations-wrapper').prepend(prod_quantity_mob)

  }






    window.addEventListener('load', function () {




         $('.btn-dec').on('click', function(){
      	console.log("decrease");
          let inputfield = $(this).next();
        	let currVal = $(inputfield).val();
        	if( parseInt(currVal) > parseInt(1)){
        	$(inputfield).val(parseInt(currVal) - parseInt(1));
        }
      })

      $('.btn-inc').on('click', function(){
      	console.log("increase");
        	let inputfield = $(this).prev();
        	let currVal = $(inputfield).val();

        	$(inputfield).val(parseInt(currVal) + parseInt(1));

      })


    });



$('.product-variant-select').change(function(){
  var variantPrice = $(this).children('option:selected').data('variantprice');
  var variantComparePrice = $(this).children('option:selected').data('variantcompare');

  $('.mpi-price h5 u').html(variantPrice)

  console.log("VP :",variantPrice )

  if(variantComparePrice != "")
  {
    $('.mpi-price h5 s').html(variantComparePrice)
  }

   
});
 


  //copy promo to clipboard


    let buttonElement = document.querySelector('.promo-copy-code')
    let text = document.querySelector('.promo-copy-code').innerHTML;
    const copyContent = async () => {
      try {
        await navigator.clipboard.writeText(text);
        console.log('Content copied to clipboard');
        buttonElement.classList.add("promo-copied");
        document.querySelector('.mpi-pwd-code small').innerHTML = "Coupon Copied";
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $('body').on('click', '.buy-now-btn-custom', function () {
    console.log('YO BUY NO CLICKED');

    $('.buy-now-custom-text').hide();
    $('.buy-now-btn-custom .loading-overlay__spinner').removeClass('hidden');

    var formParams = $('form.form').serialize();
    $.ajax({
      url: '/cart/add',
      type: 'post',
      data: formParams,
      success: function () {
        console.log('Added buy now');
        window.location.href = '/checkout';
      },
      error: function () {
        console.log('Error buy now');
      },
    });
  });

  $('.product-popup-close').on('click', function () {
    $('.product-popup').fadeOut();
  });
  $('.product-popup-btn').on('click', function () {
    console.log('Clicked');
    $('.product-popup').fadeIn();

    var datatext = $(this).attr('data-targetit');
    console.log(datatext);
    if (datatext == 'box-keyfeatures') {
      $('.product-popup-tabs li').siblings().removeClass('active');
      $('.product-popup-tabs li:nth-child(1)').addClass('active');
    } else if (datatext == 'box-specs') {
      $('.product-popup-tabs li').siblings().removeClass('active');
      $('.product-popup-tabs li:nth-child(2)').addClass('active');
    } else if (datatext == 'box-details') {
      $('.product-popup-tabs li').siblings().removeClass('active');
      $('.product-popup-tabs li:nth-child(3)').addClass('active');
    }
  });

  // Function to generate a random number in the range 100 to 600 (inclusive)
  function getRandomNumberInRange() {
    const min = 100;
    const max = 200;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // Call the function and store the random number in a variable
  const randomNumber = getRandomNumberInRange();
  console.log(randomNumber);

  $('.ppb-count').html(randomNumber);

  $('.product-carousel-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: false,
    asNavFor: '.product-carousel-thumbnails',
  });
  $('.product-carousel-thumbnails').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-carousel-main',
    dots: false,
    arrows: false,
    focusOnSelect: true,
  });

  var prod_quantity_mob = $('.mpi-quantity');

  if ($(window).width() < 767) {
    console.log(prod_quantity_mob);

    $('.main-product-info .mpi-variations-wrapper').prepend(prod_quantity_mob);
  }

  window.addEventListener('load', function () {
    $('.btn-dec').on('click', function () {
      console.log('decrease');
      let inputfield = $(this).next();
      let currVal = $(inputfield).val();
      if (parseInt(currVal) > parseInt(1)) {
        $(inputfield).val(parseInt(currVal) - parseInt(1));
      }
    });

    $('.btn-inc').on('click', function () {
      console.log('increase');
      let inputfield = $(this).prev();
      let currVal = $(inputfield).val();

      $(inputfield).val(parseInt(currVal) + parseInt(1));
    });
  });

  $('.product-variant-select').change(function () {
    var variantPrice = $(this).children('option:selected').data('variantprice');
    var variantComparePrice = $(this).children('option:selected').data('variantcompare');

    $('.mpi-price h5 u').html(variantPrice);

    console.log('VP :', variantPrice);

    if (variantComparePrice != '') {
      $('.mpi-price h5 s').html(variantComparePrice);
    }
  });

  //copy promo to clipboard

  let buttonElement = document.querySelector('.promo-copy-code') !== null;

  if (buttonElement) {
    let text = document.querySelector('.promo-copy-code').innerHTML;
    const copyContent = async () => {
      try {
        await navigator.clipboard.writeText(text);
        console.log('Content copied to clipboard');
        buttonElement.classList.add('promo-copied');
        document.querySelector('.mpi-pwd-code small').innerHTML = 'Coupon Copied';
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    };
  }

  // window.addEventListener('load', function () {
  // let checkInstallation = document.querySelector("#tcustomizer-app")  !== null;

  // if(checkInstallation)
  // {
  // $('.product-form').prepend(checkInstallation);
  // }

  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-powerhouse"]) return;
  try {
    



  document.addEventListener('DOMContentLoaded', function() {
    var variantRadios = document.querySelectorAll('#product-variants input[type="radio"]');
    
    variantRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        var selectedVariantId = this.value;
        var variant = product.variants.find(function(variant) {
          return variant.id == selectedVariantId;
        });

        // Update the product price, SKU, image, or any other elements as needed
        // For example:
        // document.getElementById('product-price').innerText = variant.price | money;
        // document.getElementById('product-sku').innerText = variant.sku;
        // document.getElementById('product-image').src = variant.featured_image.src;
      });
    });
  });



  } catch(e) { console.error(e); }
})();
})();
